const translations = {
  "en": {
    "and": "and",
    "Privacy Policy": "Privacy Policy",
    "Terms of Use": "Terms of Use"
  },
  "zh-tw": {
    "and": "和",
    "Privacy Policy": "隱私權政策",
    "Terms of Use": "使用條款"
  }
};

export default translations;
